<template>
  <v-container
    fluid
    ma-0
    pa-0
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs1>
        <v-select
          :items="accountHolders.filter(x => x.holderType == 0)"
          v-model="employee.salutation"
          label="Salutation"
          item-text="description"
          item-value="code"
          v-validate="'required'"
          name="salutation"
          :error-messages="errors.collect('salutation')"
        ></v-select>
      </v-flex>
      <v-flex xs3>
        <v-text-field
          name="firstName"
          label="First Name"
          id="firstName"
          v-model="employee.firstName"
          v-validate="'required'"
          :error-messages="errors.collect('firstName')"
        ></v-text-field>
      </v-flex>
      <v-flex xs3>
        <v-text-field
          name="lastName"
          label="Last Name"
          id="lastName"
          v-model="employee.lastName"
          v-validate="'required'"
          :error-messages="errors.collect('lastName')"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
    >
      <v-flex xs3>
        <v-text-field
          name="email"
          label="Email"
          id="email"
          v-model="employee.email"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-select
          :items="accountHolders.filter(x => x.holderType == 1)"
          v-model="employee.jobTitle"
          label="Job Title"
          item-text="description"
          item-value="code"
          v-validate="'required'"
          name="jobTitle"
          :error-messages="errors.collect('jobTitle')"
        ></v-select>
      </v-flex>

      <v-flex xs2>
        <v-text-field
          name="phoneNumber"
          label="Phone Number"
          id="phoneNumber"
          v-model="employee.phoneNumber"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
    >
      <v-btn
        :disabled="errors.any() || !employee.phoneNumber || loading"
        color="primary"
        @click="submit(false)"
      >Continue</v-btn>

      <v-btn flat>Cancel</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "QantasEmployee",
  props: {
    employee: {
      type: Object,
      required: true
    },
    accountHolders: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean, required: true
    }
  },
  methods: {
    submit (validate) {
      return new Promise((resolve, reject) => {
        let vm = this;
        vm.$validator.validateAll().then(result => {
          if (result) {
            vm.hasErrors = false;
            if (!validate) vm.$emit("updated", vm.employee);
            resolve(result);
          } else {
            vm.hasErrors = true;
            reject(result);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>